<p-inputMask
  [disabled]="disabled" [(ngModel)]="timestampString" (onBlur)="onBlur()"
  [ngClass]="{ 'border-disabled': disableBorder }"
  mask="9:99:99" slotChar="0" (ngModelChange)="onModelChange()" [inputId]="inputName"
></p-inputMask>
